module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABMAAAAQCAYAAAD0xERiAAABWElEQVQ4jZ2TMUscURRGzwjpLWxkAwFJaxrBRdInhfbWQkD/QFJZzBT+lmzcYmEJBKy0MIKIiminZEGwiMhuYbVmciy8I8MwMLofXB738n2H9x7vJSo1WgBWgU/AO2AaGAEDYAfoACcAWZY9h6YqkBbQB46Ar8AscAj8iLUFfAOOgV70z0pKO2sDP4EZ4BewBfwGyltPgI/AJvAZuAVWsiw7BEBFfa8O1Vxdj1lTbYR/qM6laQpqoh74pLUXgor6Erl9NUFdiUHvlaCi+pFfRu1G054QthT5DuqN+ndCEGmaot6p1wR1rA7US/W72mqAvFW3wz+IvAXsXj1VL6LfbYDthe88cvdlWDl8oY4aYOMAFcfcVa3+AICHuv9V0RvgX3VYB5tYBSwpzZI6Y0V5bUb9E3fQiTeXq8cNd3YSvm7kxuoVPj3WM/V/GI7U+QbYh/DlkTtTFx8BEJWTL56U1eIAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_st.png
// module id = CJFK
// module chunks = 1